import { c as _c } from "react/compiler-runtime";
import { COOKIES } from '@libs/core';
import type { Decisions } from '../types';
import { getDecisions } from '../utils/parseDecisions';
import { useCacheKey } from './useCacheKey';
import { useOptimizely } from './useOptimizely';
export function useDecisions(): Decisions;
export function useDecisions<F extends keyof Decisions>(flag: F): Decisions[F];
export function useDecisions(flag) {
  const $ = _c(5);
  const {
    context
  } = useOptimizely();
  const {
    cookies
  } = useCacheKey();
  let t0;
  if ($[0] !== context || $[1] !== cookies) {
    let t1;
    if ($[3] !== context) {
      t1 = flag_0 => context?.decide(flag_0);
      $[3] = context;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = getDecisions({
      raw: cookies.get(COOKIES.X_PETM_DECISIONS),
      onFlagRead: t1
    });
    $[0] = context;
    $[1] = cookies;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const proxy = t0;
  if (!flag) {
    return proxy;
  }
  return proxy[flag];
}